enum TileType {
  Service = 'Service',
  Media = 'Media',
}

export default TileType;
